import { useCallback } from 'react';
import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { useUpdateAccountantEmissorContractBeneficiaryMutation, useUpdateClientEmissorContractBeneficiaryMutation, } from '../services/contractBeneficiariesApi';
export function useEmissorUpdateBeneficiary() {
    const appDomain = useAppSelector(selectAppDomain);
    const isAccountant = appDomain === AppDomain.ESCRITORIO;
    const [updateAccountant, accountantState] = useUpdateAccountantEmissorContractBeneficiaryMutation();
    const [updateClient, clientState] = useUpdateClientEmissorContractBeneficiaryMutation();
    const trigger = isAccountant ? updateAccountant : updateClient;
    const isUpdating = isAccountant ? accountantState.isLoading : clientState.isLoading;
    const updateBeneficiary = useCallback(async ({ contractId, beneficiaryId, body }) => {
        await trigger({ contractId, beneficiaryId, body }).unwrap();
    }, [trigger]);
    return { updateBeneficiary, isUpdating };
}
